import { render, staticRenderFns } from "./SetPWContent.vue?vue&type=template&id=a33f7416&"
import script from "./SetPWContent.vue?vue&type=script&lang=js&"
export * from "./SetPWContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports